import { useTheme } from '@mui/material';
import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid2";
import Paper from "@mui/material/Paper";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";
import _ from 'lodash';
import { lighter } from '../../common/util';
import ActivityCard from '../../enrollment/activity.card';
import StudentName from '../../student/student.name';
import { userApi } from '../../user/user.queries';

export default function UpcomingView(props) {
	const upcomingFetch = userApi.useUpcoming();
	const activities = upcomingFetch.data;
	const theme = useTheme();

	const students = _.chain(activities).map('enrollment.student').uniqBy('id').orderBy('name').filter().value();
	const activityMap = _.groupBy(activities, 'enrollment.studentId');

	if (!activities) {
		return;
	}

	const renderStudents = (students) => {
		return students.map(student => {
			const key = student.id;
			const studentSx = { p: 2, background: lighter(student.colour, 0.8, theme) };
			let studentActivities = activityMap[student.id];
			studentActivities = _.chain(studentActivities)
				.filter(activity => activity?.courseDetail?.isParent == false && activity?.startDate != null)
				.orderBy(['courseDetail.course.subject.name', 'courseDetail.course.name', 'courseDetail.ordinal'])
				.value();
			return (
				<Grid size={{ xs: 12, md: 6, xl: 4 }} key={key}>
					<Paper sx={studentSx}>
						<Stack alignItems="center">
							<StudentName student={student} size={24} variant="h5" />
						</Stack>
						<Stack direction="column">
							{studentActivities.map((activity, i) =>
								<ActivityCard activity={activity} hideStudent={true} key={activity.id} />
							)}
						</Stack>
					</Paper>
				</Grid>
			)
		});
	};

	return (
		<Box sx={{ p: 2 }}>
			<Stack justifyContent="space-around" alignItems="center">
				<Typography variant="h5">Upcoming</Typography>
			</Stack>

			<Grid container sx={{ pt: 2 }}>
				{renderStudents(students)}
			</Grid>
		</Box>
	);
}